"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ConnectedLoadableApp = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));

var _reactI18next = require("react-i18next");

var _reactRedux = require("react-redux");

var _createAction = require("../../redux/createAction");

var _UserActions = require("../../User/models/UserActions");

var _isAppDisabled = require("../shared/isAppDisabled");

var _LoadableApp = require("./LoadableApp");

/**
 * Maps the external (i.e. own) props and the state to the properties of the AuthenticatedContent control.
 * @param state The current redux state to map to props
 * @param ownProps The external properties to map to props
 * @returns The mapped properties that along with the actions
 * becomes the props (IAuthenticatedContentProps) for the AuthenticatedContent control
 */
var mapStateToProps = function mapStateToProps() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location;
  return function (state, props) {
    var appDisabled = process.env.APP_SUITE_ENABLED === 'true' && !!process.env.APP_SUITE_APP_KEY && props.authorizationProps && (0, _isAppDisabled.isAppDisabled)(props.authorizationProps, state.appSuite);
    var enabledAuthorization = process.env.APP_SUITE_ENABLED === 'true';

    if (process.env.NODE_ENV === 'development') {
      var loc = new _url.default(location.href);

      if (loc.searchParams.has('enableCheck')) {
        enabledAuthorization = loc.searchParams.get('enableCheck') === 'true';
      }
    }

    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
      isLoading: props.isLoading || state.user.flights.isLoading || !!(process.env.APP_SUITE_ENABLED === 'true' && !!process.env.APP_SUITE_APP_KEY && enabledAuthorization && (state.appSuite.enabledApps.isLoading || state.appSuite.enabledApps.loadingError || appDisabled)),
      isBooting: state.user.flights.isLoading || state.user.isLoading
    });
  };
};
/**
 * Maps the dispatch actions to the props for the AuthenticatedContent control.
 * @param dispatch Dispatches actions to the store
 * @returns The mapped actions that along with the mapped properties
 * becomes the props (IAuthenticatedContentProps) for the AuthenticatedContent control
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    boot: (0, _createAction.createAction)(_UserActions.UserActions.getFlights, dispatch)
  };
};
/**
 * A redux connected AuthenticatedContent control.
 */


var ConnectedLoadableApp = (0, _reactRedux.connect)(mapStateToProps(), mapDispatchToProps, undefined, {
  pure: false
} // Container control
)((0, _reactI18next.translate)('App')(_LoadableApp.LoadableApp));
exports.ConnectedLoadableApp = ConnectedLoadableApp;